import { Modal } from '@/components/ui';
import { useConfirm } from '@/stores/confirm';

/** Shows whatever confirmAction() is asking. Mounted once, by App. */
export function ConfirmHost() {
  const open = useConfirm((s) => s.open);
  if (!open) return null;

  return (
    <Modal title={open.title} onClose={() => open.resolve(false)}>
      <div className="stack">
        <h2>{open.title}</h2>
        <p>{open.message}</p>
        <div className="formactions">
          <button type="button" className="btn" onClick={() => open.resolve(false)}>
            {open.cancelLabel ?? 'Cancel'}
          </button>
          <span className="formactions__spacer" />
          <button
            type="button"
            className={`btn ${open.danger ? 'btn--danger' : 'btn--primary'}`}
            onClick={() => open.resolve(true)}
          >
            {open.confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
}
